import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_181_stock_correction: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Stock Correction Summary",
      "fabAction": {
          "type": "add",
          "screenId": "182",
          "action": "modulev1/stock_correction_add"
      },
      "style": {
          "backgroundColor": "#F9FAFB"
      },
      "childComponents": [
          {
              "componentType": "group",
              "style": {
                  "backgroundColor": "#ffffff",
                  "direction": "column",
                  "borderRadius": 12,
                  "padding": 16
              },
              "childComponents": [
                  {
                      "componentType": "summeryList",
                      "titleValue": "Stock Corrections",
                      "SummeryActions": [],
                      "Form": {
                          "Name": "stock_correction_summary",
                          "TableName": "stock_correction",
                          "Query": "SELECT stock_correction.id, stock_correction.product_id, stock_correction.batch_id, stock_correction.stock_action, stock_correction.quantity, stock_correction.remarks, concat(item_master.part_no, ' | ', item_master.item_name) AS product_name, batch.batch_no FROM stock_correction INNER JOIN item_master ON stock_correction.product_id = item_master.id LEFT JOIN batch ON stock_correction.batch_id = batch.id WHERE stock_correction.soft_delete = 0",
                          "Fields": [
                              {
                                  "IncludeLabel": true,
                                  "Label": "ID",
                                  "BindValue": "id",
                                  "Json_Attribute": "id",
                                  "componentType": "textField",
                                  "showInSummary": false,
                                  "IsPrimary": true
                              },
                              {
                                  "IncludeLabel": true,
                                  "Label": "Product",
                                  "BindValue": "product_name",
                                  "Json_Attribute": "product_name",
                                  "componentType": "textField",
                                  "showInSummary": true
                              },
                              {
                                  "IncludeLabel": true,
                                  "Label": "Batch",
                                  "BindValue": "batch_no",
                                  "Json_Attribute": "batch_no",
                                  "componentType": "textField",
                                  "showInSummary": true
                              },
                              {
                                  "IncludeLabel": true,
                                  "Label": "Action",
                                  "BindValue": "stock_action",
                                  "Json_Attribute": "stock_action",
                                  "componentType": "textField",
                                  "showInSummary": true
                              },
                              {
                                  "IncludeLabel": true,
                                  "Label": "Quantity",
                                  "BindValue": "quantity",
                                  "Json_Attribute": "quantity",
                                  "componentType": "textField",
                                  "showInSummary": true
                              },
                              {
                                  "IncludeLabel": true,
                                  "Label": "Remarks",
                                  "BindValue": "remarks",
                                  "Json_Attribute": "remarks",
                                  "componentType": "textField",
                                  "showInSummary": true
                              }
                          ]
                      }
                  }
              ]
          }
      ]
  }
];
